// extracted by mini-css-extract-plugin
export default {"input":"G8-z","button":"H8-z","selected":"I8-z","unavailable":"J8-z","oos":"K8-z","image":"L8-z","paperCutDisabledOverlay":"M8-z"};